export default __webpack_public_path__ + "static/media/reason6.47016261.svg";